import {PayloadAction} from '@reduxjs/toolkit';
import campaignOptimizationReducer from './campaignOptimization/campaignOptimization.slice';
import campaignMediaVariationsReducer from './campaignMediaVariations/campaignMediaVariations.slice';
import campaignVariationsAnalysisReducer from './campaignVariationsAnalysis/campaignVariationsAnalysis.slice';
import campaignBaseReducer from './campaignBase/campaignBase.slice';
import campaignTreeReducer from './campaignTree/campaignTree.slice';
import campaignLogicReducer from './campaignLogicTab/campaignLogic.slice';
import insightsTabReducer from './insightsTab/insightsTab.slice';
import adsetsTabReducer from './adsetsTab/adsetsTab.slice';
import adsTabReducer from './adsTab/adsTab.slice';
import {CampaignOptimizationState} from './campaignOptimization/campaignOptimization.types';
import {AdSetsPageState} from './adsetsTab/adsetsTab.types';
import {AdsTabState} from './adsTab/adsTab.types';
import {CampaignMediaVariationsState} from './campaignMediaVariations/campaignMediaVariations.types';
import {CampaignVariationsAnalysisState} from './campaignVariationsAnalysis/campaignVariationsAnalysis.types';
import {CampaignBaseState} from './campaignBase/campaignBase.types';
import {CampaignTreeState} from './campaignTree/campaignTree.types';
import {CampaignLogicState} from './campaignLogicTab/campaignLogic.types';
import {InsightsTabState} from './insightsTab/insightsTab.types';

//will be added: base campaign page reducer

type CampaignPageReducerState = CampaignBaseState & {
  optimization: CampaignOptimizationState;
  adsetsTab: AdSetsPageState;
  adsTab: AdsTabState;
  mediaVariations: CampaignMediaVariationsState;
  variationsAnalysis: CampaignVariationsAnalysisState;
  campaignTree: CampaignTreeState;
  campaignLogic: CampaignLogicState;
  insightsTab: InsightsTabState;
};

const campaignPageReducer = (
  state: CampaignPageReducerState,
  action: PayloadAction,
): CampaignPageReducerState => {
  const campaignBaseState = campaignBaseReducer(state, action);
  const optimizationState = campaignOptimizationReducer(state?.optimization, action);
  const adsetsTabState = adsetsTabReducer(state?.adsetsTab, action);
  const adsTabState = adsTabReducer(state?.adsTab, action);
  const mediaVariationsState = campaignMediaVariationsReducer(state?.mediaVariations, action);
  const variationsAnalysisState = campaignVariationsAnalysisReducer(
    state?.variationsAnalysis,
    action,
  );

  const campaignTreeState = campaignTreeReducer(state?.campaignTree, action);
  const campaignLogicState = campaignLogicReducer(state?.campaignLogic, action);
  const insightsTabState = insightsTabReducer(state?.insightsTab, action);

  return {
    ...campaignBaseState,
    optimization: optimizationState,
    adsetsTab: adsetsTabState,
    adsTab: adsTabState,
    mediaVariations: mediaVariationsState,
    variationsAnalysis: variationsAnalysisState,
    campaignTree: campaignTreeState,
    campaignLogic: campaignLogicState,
    insightsTab: insightsTabState,
  };
};

export default campaignPageReducer;
